import { render, staticRenderFns } from "./ServicesTypeAdd.vue?vue&type=template&id=0b894acd&scoped=true&"
import script from "./ServicesTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ServicesTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b894acd",
  null
  
)

export default component.exports